import { openDialog } from "@/src/components/dialogs";
import {
  Field,
  FieldAnswer,
  medicineHoraires,
  Patient,
  PatientItemStatus,
  patientItemStatuses,
  RefAnswer,
  Reference,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import moment from "moment";
import { start } from "repl";
import { ReferenceFieldsForm } from "../../fields/referenceFieldsForm";
import { useState } from "react";
import { Input } from "@/src/components/universalInput";

function AnswersTimelineForm({
  patient,
  reference,
  field,
  currentAnswer,
  start,
  onChange,
}: {
  patient: Patient;
  reference: Reference;
  field: Field;
  currentAnswer: FieldAnswer;
  start: string;
  onChange: (answer: FieldAnswer) => void;
}) {
  const [answer, setAnswer] = useState<FieldAnswer>(currentAnswer);
  function getTimesOptions() {
    let times: { label: string; value: string }[] = [];
    let incrementMinutes: number = 60;
    let time: string = moment(start).format("YYYY-MM-DD 00:00:00");
    let maxTime: string = moment(start).format("YYYY-MM-DD 23:59:59");
    while (moment(time).isBefore(moment(maxTime))) {
      times.push({
        label: moment(time).format("HH : mm"),
        value: moment(time).format("HH:mm:00"),
      });
      time = moment(time)
        .add(incrementMinutes, "minutes")
        .format("YYYY-MM-DD HH:mm:00");
    }
    return times;
  }
  return (
    <div className="c1 gap10">
      <ReferenceFieldsForm
        patient={patient}
        isHorizontal={false}
        reference={reference}
        currentAnswers={[answer]}
        specificFieldIds={[getItemId(field)]}
        showSectionTitles={false}
        onChange={(newValue) => {
          setAnswer(newValue[0]!);
          onChange(newValue[0]!);
        }}
      />
      <Input
        name={"Notes"}
        type="textarea"
        placeholder="Notes"
        value={answer.notes}
        onChange={(newValue) => {
          setAnswer({
            ...answer,
            notes: newValue,
          });
          onChange(answer);
        }}
      />
      <div className="c2 gap10">
        <Input
          name={"De"}
          type="select"
          options={getTimesOptions()}
          value={moment(answer.start).format("HH:mm:00")}
          onChange={(newValue) => {
            setAnswer({
              ...answer,
              start: `${moment(newValue).format("YYYY-MM-DD")} ${newValue}`,
            });
            onChange(answer);
          }}
        />
        <Input
          name={"A"}
          type="select"
          options={getTimesOptions()}
          value={moment(answer.end).format("HH:mm:00")}
          onChange={(newValue) => {
            setAnswer({
              ...answer,
              end: `${moment(newValue).format("YYYY-MM-DD")} ${newValue}`,
            });
            onChange(answer);
          }}
        />
      </div>
      {/* <Input
        name={""}
        type="chips"
        value={answer.status}
        options={Object.values(patientItemStatuses)
          .filter((status) => status.id == "pending" || status.id == "finished")
          .map((status) => {
            return {
              value: status.id,
              label: status.name,
            };
          })}
        onChange={(newValue) => {
          console.log("theeee new status", newValue);
          setAnswer({
            ...answer,
            status: newValue,
          });
          onChange({...answer});
        }}
      /> */}
    </div>
  );
}

export async function openAnswersTimelineForm({
  patient,
  reference,
  fieldAnswer,
  field,
  start,
  end,
  initialStatus = "finished",
  onSave,
}: {
  patient: Patient;
  fieldAnswer: FieldAnswer | null | undefined;
  reference: Reference;
  field: Field;
  start: string;
  end?: string;
  initialStatus?: PatientItemStatus;
  onSave: (answer: FieldAnswer) => void;
}) {
  if (!fieldAnswer) {
    fieldAnswer ||= {
      patient,
      parent: null,
      creator: getUserId(),
      doctor: getUserId(),
      field,
      start,
      end: end || moment(start).add(1, "hour").format("YYYY-MM-DD HH:mm"),
      finishedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      status: initialStatus,
      notes: "",
      value: null,
    };
  }

  await openDialog({
    id: "uniqueTaskDrawer",
    title: "Ajouter un élément",
    content: (
      <AnswersTimelineForm
        patient={patient}
        reference={reference}
        field={field}
        currentAnswer={fieldAnswer}
        start={start}
        onChange={(answer) => {
          fieldAnswer = answer;
          console.log("chaaaanging fieldAnswer", fieldAnswer);
        }}
      />
    ),
    onConfirm: async () => {
      if (!fieldAnswer) throw new Error("fieldAnswer is null");

      fieldAnswer = await apiFetch(
        "fieldAnswers",
        "addOne",
        { fieldAnswer: fieldAnswer },
        "Erreur lors de l'ajout de la réponse"
      );
      console.log("saaaving fieldAnswer", fieldAnswer);

      if (!fieldAnswer.parent) {
        let refAnswer: RefAnswer = {
          creator: getUserId(),
          patient,
          status: initialStatus,
          reference: reference,
          fieldAnswers: [fieldAnswer],
        };

        refAnswer = await apiFetch(
          "refAnswers",
          "addOne",
          { refAnswer },
          "Erreur lors de la création de la réponse"
        );
        fieldAnswer.parent = getItemId(refAnswer);
        fieldAnswer = await apiFetch(
          "fieldAnswers",
          "addOne",
          { fieldAnswer: fieldAnswer },
          "Erreur lors de l'ajout de la réponse"
        );
      }

      onSave(fieldAnswer);
    },
  });
}
